export let allowWarnings = false
export let nullString = '- - -'

/// ////////////////////////
// INTERNAL FUNCTIONS
/// ///////////////////////

export function arraysEqual (arr1, arr2) {
  if (arr1.length !== arr2.length) { return false }
  for (var i = arr1.length; i--;) {
    if (arr1[i] !== arr2[i]) { return false }
  }

  return true
}

export function compareAttributes (_arr1, _arr2) {
  if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length) {
    return false
  }

  if (!Array.isArray(_arr1) && !Array.isArray(_arr2)) {
    return _arr1 === _arr2
  }

  var arr1 = _arr1.concat().sort()
  var arr2 = _arr2.concat().sort()

  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) { return false }
  }

  return true
}

export function flatten (array, mutable) {
  var toString = Object.prototype.toString
  var arrayTypeStr = '[object Array]'

  var result = []
  var nodes = (mutable && array) || array.slice()
  var node

  if (!array.length) {
    return result
  }

  node = nodes.pop()

  do {
    if (toString.call(node) === arrayTypeStr) {
      nodes.push.apply(nodes, node)
    } else {
      result.push(node)
    }
  } while (nodes.length && (node = nodes.pop()) !== undefined)

  result.reverse() // we reverse result to restore the original order
  return result
}

export function capitalize (string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : ''
}

export function singularize (string) {
  return string.substring(string.length - 1) === 's' ? string.substring(0, string.length - 1) : string
}

// ---------------- Search helpers ---------------- //

export function formatMoney (amount, decimalCount = 2, decimal = '.', thousands = ',') {
  try {
    decimalCount = Math.abs(decimalCount)
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount

    const negativeSign = amount < 0 ? '-' : ''

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
    let j = (i.length > 3) ? i.length % 3 : 0

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
  } catch (e) {
  }
};

export function cloneObject (obj) {
  if (obj == null || typeof (obj) !== 'object') { return obj }

  var temp = new obj.constructor()
  for (var key in obj) { temp[key] = cloneObject(obj[key]) }

  return temp
}

export function objectsAreSame (x, y) {
  var objectsAreSame = true
  for (var propertyName in x) {
    if (x[propertyName] !== y[propertyName]) {
      objectsAreSame = false
      break
    }
  }
  return objectsAreSame
}

export function arraysAreSame (ary1, ary2) {
  return (ary1.join('') === ary2.join(''))
}
